function validateName(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return 'El nombre es obligatorio';
  if (trimmed.length < 2) return 'El nombre debe tener al menos 2 caracteres';
  if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜçÇ\s.'-]{2,60}$/.test(trimmed)) {
    return 'El nombre solo puede contener letras y espacios';
  }
  return '';
}

function validateEmail(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return 'El email es obligatorio';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
    return 'Introduce una dirección de email válida';
  }
  return '';
}

function validatePhone(value) {
  const cleaned = (value || '').replace(/\D/g, '');
  if (!cleaned) return 'El teléfono es obligatorio';
  if (!/^[6789]\d{8}$/.test(cleaned)) {
    return 'Introduce un número de teléfono válido de 9 dígitos';
  }
  return '';
}

function validatePrivacy(checked) {
  if (!checked) return 'Debes aceptar la política de privacidad';
  return '';
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[1]) : null;
}

const TRACKING_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'promotor'];

function captureAndGetTrackingData() {
  const urlParams = new URLSearchParams(window.location.search);
  const tracking = {
    _fbc: getCookie('_fbc'),
    _fbp: getCookie('_fbp'),
  };

  TRACKING_KEYS.forEach((key) => {
    const paramValue = urlParams.get(key);
    if (paramValue) {
      try {
        localStorage.setItem(`c_${key}`, paramValue);
      } catch (_) {}
      tracking[key] = paramValue;
    } else {
      try {
        tracking[key] = localStorage.getItem(`c_${key}`);
      } catch (_) {
        tracking[key] = null;
      }
    }
  });

  return tracking;
}

export default class FsPeticionInfo extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.abortController = new AbortController();
    const signal = this.abortController.signal;

    this.nameInput = this.querySelector('input[name="nombre"]');
    this.emailInput = this.querySelector('input[name="email"]');
    this.phoneInput = this.querySelector('input[name="telefono"]');
    this.privacyCheckbox = this.querySelector('input[name="privacidad"]');
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.submitText = this.querySelector('[data-submit-text]');
    this.submitSpinner = this.querySelector('[data-submit-spinner]');

    // Estado inicial limpio del spinner y texto
    if (this.submitSpinner) {
      this.submitSpinner.setAttribute('hidden', '');
      this.submitSpinner.style.display = 'none';
    }
    if (this.submitText) {
      this.submitText.removeAttribute('hidden');
      this.submitText.style.display = '';
    }

    this.populateHiddenFields();

    if (this.nameInput) {
      this.nameInput.addEventListener('blur', () => this.validateField('name'), { signal });
      this.nameInput.addEventListener('input', () => this.clearError('name'), { signal });
    }

    if (this.emailInput) {
      this.emailInput.addEventListener('blur', () => this.validateField('email'), { signal });
      this.emailInput.addEventListener('input', () => this.clearError('email'), { signal });
    }

    if (this.phoneInput) {
      this.phoneInput.addEventListener(
        'input',
        () => {
          if (this.phoneInput) {
            this.phoneInput.value = this.phoneInput.value.replace(/\D/g, '').slice(0, 9);
          }
          this.clearError('phone');
        },
        { signal },
      );
      this.phoneInput.addEventListener('blur', () => this.validateField('phone'), { signal });
    }

    if (this.privacyCheckbox) {
      this.privacyCheckbox.addEventListener('change', () => this.validateField('privacy'), { signal });
    }

    this.form.addEventListener('submit', this.handleSubmit.bind(this), { signal });
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  validateField(field) {
    let error = '';

    if (field === 'name' && this.nameInput) {
      error = validateName(this.nameInput.value);
    } else if (field === 'email' && this.emailInput) {
      error = validateEmail(this.emailInput.value);
    } else if (field === 'phone' && this.phoneInput) {
      error = validatePhone(this.phoneInput.value);
    } else if (field === 'privacy' && this.privacyCheckbox) {
      error = validatePrivacy(this.privacyCheckbox.checked);
    }

    if (error) {
      this.showError(field, error);
      return false;
    }

    this.clearError(field);
    return true;
  }

  showError(field, message) {
    const errorEl = this.querySelector(`[data-error="${field}"]`);
    const inputName =
      field === 'privacy' ? 'privacidad' : field === 'name' ? 'nombre' : field === 'phone' ? 'telefono' : 'email';
    const inputEl = this.querySelector(`[name="${inputName}"]`);

    if (errorEl) {
      errorEl.textContent = message;
      errorEl.removeAttribute('hidden');
      errorEl.style.display = 'block';
    }

    if (inputEl) {
      inputEl.setAttribute('aria-invalid', 'true');
    }
  }

  clearError(field) {
    const errorEl = this.querySelector(`[data-error="${field}"]`);
    const inputName =
      field === 'privacy' ? 'privacidad' : field === 'name' ? 'nombre' : field === 'phone' ? 'telefono' : 'email';
    const inputEl = this.querySelector(`[name="${inputName}"]`);

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.setAttribute('hidden', '');
      errorEl.style.display = 'none';
    }

    if (inputEl) {
      inputEl.removeAttribute('aria-invalid');
    }
  }

  validateAll() {
    const nameOk = this.validateField('name');
    const emailOk = this.validateField('email');
    const phoneOk = this.validateField('phone');
    const privacyOk = this.validateField('privacy');

    return nameOk && emailOk && phoneOk && privacyOk;
  }

  populateHiddenFields() {
    const trackingData = captureAndGetTrackingData();
    const formMapping = {
      utm_source: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_content: 'utm_content',
      utm_term: 'utm_term',
      promotor: 'promotor',
      _fbc: '_fbc',
      _fbp: '_fbp',
    };

    for (const [key, fieldName] of Object.entries(formMapping)) {
      const val = trackingData[key];
      if (val) {
        const input = this.querySelector(`input[name="${fieldName}"]`);
        if (input) {
          input.value = val;
        }
      }
    }
  }

  handleSubmit(event) {
    this.populateHiddenFields();

    if (!this.validateAll()) {
      event.preventDefault();
      return;
    }

    if (this.submitBtn) {
      this.submitBtn.disabled = true;
      this.submitBtn.classList.add('opacity-75', 'cursor-not-allowed');
    }
    if (this.submitText) {
      this.submitText.setAttribute('hidden', '');
      this.submitText.style.display = 'none';
    }
    if (this.submitSpinner) {
      this.submitSpinner.removeAttribute('hidden');
      this.submitSpinner.style.display = 'inline-flex';
    }
  }
}

if (!customElements.get('fs-peticion-info')) {
  customElements.define('fs-peticion-info', FsPeticionInfo);
}
